<template>
    <div>
        <b-row>
            <b-col cols="12" md="4">
                <ValidationProvider name="academic_year" rules="" v-slot="{ valid, errors }">
                    <b-form-group :label="$t('session')">
                        <academic-years-selectbox
                            :validateError="errors[0]"
                            v-model="academic_year"
                        />
                    </b-form-group>
                </ValidationProvider>
            </b-col>
            <b-col cols="12" md="2">
                <b-form-group class="mb-0">
                    <label class="d-none d-md-block">&nbsp;</label>
                    <b-button variant="primary" block @click="getReport">
                        {{ $t('get_report').toUpper() }}
                    </b-button>
                </b-form-group>
            </b-col>
        </b-row>
    </div>
</template>
<script>

import MinorApplicationService from "@/services/MinorApplicationService";
import AcademicYearsSelectbox from "@/components/interactive-fields/AcademicYearsSelectbox"
import qs from "qs";

export default {
    components: {
        AcademicYearsSelectbox
    },
    data() {
        return {
            academic_year: null
        }
    },
    methods: {

        getReport(){
            const config = {
                params: {
                    academic_year: this.academic_year
                },
                paramsSerializer: (params) => qs.stringify(params, {encode: false})
            }
            MinorApplicationService.yokReport(config)
                .then(res=>this._downloadFile(res,this.$t('minor_applications_yok_report')+'.xlsx'))
                .catch(err=>this.showErrors(err))
        }
    }
}
</script>
